import { useCallback, useRef, useState } from 'react';
import { Toasts, ToastEl } from '../ProgramSetup.styled';

interface ToastItem {
  id: number;
  message: string;
  kind?: 'ok' | 'bad';
}

// Page-scoped, minor-feedback toast (e.g. "Copied to 3 days"). Real submit
// results still go through the shared `Alert` (AntD notification) used
// app-wide — this doesn't replace it.
export const usePsToast = () => {
  const [toasts, setToasts] = useState<ToastItem[]>([]);
  const nextId = useRef(0);

  const push = useCallback((message: string, kind?: 'ok' | 'bad') => {
    const id = nextId.current++;
    setToasts((current) => [...current, { id, message, kind }]);
    setTimeout(() => {
      setToasts((current) => current.filter((toast) => toast.id !== id));
    }, 2200);
  }, []);

  return { toasts, push };
};

export const PsToasts = ({ toasts }: { toasts: ToastItem[] }) => (
  <Toasts aria-live="polite">
    {toasts.map((toast) => (
      <ToastEl key={toast.id} $kind={toast.kind}>
        <span>{toast.message}</span>
      </ToastEl>
    ))}
  </Toasts>
);
